// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"eS","newsTag":"eS","dafalut":"eT","qishou":"eU","shangjia":"eV","shehui":"eW","caiwu":"eX","piyao":"eY","suanfa":"eZ","keji":"e0","lingshou":"e1","gongzuo":"e2"};